import axios from "axios";
import { Toast } from "../../lib/helpers/helpers";
import BASE_URL from "../api";
import { NOTES_FAILED } from "../types";
import errorDispatcher from "./errorDispatcher";

// useSelector / types
const setNote = (action) => {
	return { type: "NOTE", payload: action.data, message: action.message };
};

export const createNote = async (credentials) => {
	const response = await axios.post(`${BASE_URL}/notes/create`, credentials);
	return response;
};

export const fetchNote = (credentials) => async (dispatch) => {
	try {
		const response = await axios.get(
			`${BASE_URL}/notes/view-one?noteId=${credentials}`
		);
		const { hasError } = response.data;
		if (hasError) {
			console.log(response);
			return errorDispatcher(
				response.data.errors,
				dispatch,
				NOTES_FAILED
			);
		} else {
			dispatch(setNote(response.data.data));
			Toast.fire({
				icon: "success",
				title: `Note retrieved`,
			});
			return true;
		}
	} catch (error) {
		console.log("Note Error=====>", error);
		return errorDispatcher(error, dispatch, NOTES_FAILED);
	}
};

export const fetchAllNotes = async () => {
	const response = await axios.get(`${BASE_URL}/notes/view-all`);
	return response.data;
};

export const editNote = async (credentials) => {
	const response = await axios.put(`${BASE_URL}/notes/update`, credentials);
	return response;
};

export const deleteNote = async (credentials) => {
	const response = await axios.delete(
		`${BASE_URL}/notes/delete?noteId=${credentials}`
	);
	return response;
};
